// extracted by mini-css-extract-plugin
module.exports = {"innerContentFixedSidebar":"styles_innerContentFixedSidebar__BT5Gc","ribbonDetail":"styles_ribbonDetail__ZTRo9","tel":"styles_tel__1GiDK"};